import axios from "axios";
import { DEFAULT_AUTH_HEADER } from "../../models/Constants";
import { objectToUrlQuery } from "../../helpers/Functions";

export function aiChatCompletion(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/create-chat-completion", params);
}

export function aiQuiz(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/create-ai-quiz", params);
}

export function quickAiChatCompletion(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/quick-ai-completion/1", params, DEFAULT_AUTH_HEADER);
}

export function aiSendMessageToThread(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/send-message-thread", params);
}

export function quickAISendMessageToThread(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/quick-send-message-thread", params, DEFAULT_AUTH_HEADER);
}

export function getAiUserChats(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/ai-chat-user?" + objectToUrlQuery(params));
}

export function getAiThreadInfo(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/ai-thread?" + objectToUrlQuery(params));
}

export function updateThreadDetails(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/ai-thread", params);
}

export function quickUpdateThreadDetails(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/quick-ai-thread", params, DEFAULT_AUTH_HEADER);
}

export function updateAssistantDetails(params) {
    let dataPost = new FormData();

    for (const [key, value] of Object.entries(params)) {
        if (key === "ai_tools" && Array.isArray(value)) {
            dataPost.append(key, JSON.stringify(value));
        }
        else if (key === "ai_file" && Array.isArray(value)) {
            value.forEach((file) => {
                dataPost.append('ai_file[]', file);  // Note the [] brackets
            });
        }
        else if (value !== null && value !== undefined) {
            if (typeof value === "object") {
                if (value instanceof File) {
                    dataPost.append(key, value, value.name);
                } else {
                    dataPost.append(key, JSON.stringify(value));
                }
            }
            else {
                dataPost.append(key, value);
            }
        }
    }

    return axios.post(`${process.env.REACT_APP_API_URL}/openai/ai-assistant`, dataPost, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 120000, // 2 minute timeout
    });
}

export function checkRunStatus(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/quick-check-run-status", params, DEFAULT_AUTH_HEADER);
}

export function getThreadMessages(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/thread-messages?" + objectToUrlQuery(params));
}

export function uploadFileOpenAI(params) {
    let dataPost = new FormData();

    for (const [key, value] of Object.entries(params)) {
        if (key === "ai_files" && Array.isArray(value)) {
            value.forEach((file, index) => {
                if (file.inpFile instanceof File) {
                    dataPost.append(`ai_files[${index}]`, file.inpFile);
                }
            });
        }
        else if (value !== null && value !== undefined) {
            if (typeof value === "object") {
                dataPost.append(key, JSON.stringify(value));
            }
            else {
                dataPost.append(key, value);
            }
        }
    }

    return axios.post(`${process.env.REACT_APP_API_URL}/openai-uploadfile`, dataPost,
        DEFAULT_AUTH_HEADER,
        { headers: { "Content-Type": "multipart/form-data", }, }
    );
}

export function getUserAIChats(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/ai-chat-user", params);
}

export function getPublicAssistantsList(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/public-assistants-list?" + objectToUrlQuery(params));
}

export function updateAITrialUser(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/update-trial-user", params);
}

export function deleteCompanyUserAI(params) {
    return axios.delete(process.env.REACT_APP_API_URL + "/openai/delete-company-user-ai?" + objectToUrlQuery(params));
}

export function getCompanyUsersWithAIDetails(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/company-users?" + objectToUrlQuery(params));
}

export function getCompanyAIAdvanceInfo(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/company-advance-usage-info?" + objectToUrlQuery(params));
}

export function getOpenAIFiles(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/get-open-ai-files?" + objectToUrlQuery(params));
}

export function getUserCreditUsagePerConversations(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/get-user-convo-usage?" + objectToUrlQuery(params));
}

export function getThreadConversations(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/get-user-convo-list?" + objectToUrlQuery(params));
}

export function getCompanyDraftsResponse(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/company-drafts-response?" + objectToUrlQuery(params));
}

export function enhanceAssistantInstructions(data) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/enhance-instructions", data);
}

export function getAIModelsData(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/ai-models?" + objectToUrlQuery(params));
}

export function saveAIModelData(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/ai-models", params);
}

export function listAIPrompts(params = {}) {
    const query = objectToUrlQuery(params);
    const url = `${process.env.REACT_APP_API_URL}/openai/ai-prompts${query ? `?${query}` : ''}`;
    return axios.get(url, DEFAULT_AUTH_HEADER);
}

export function updateAIPromptText(type, data = {}) {
    const url = `${process.env.REACT_APP_API_URL}/openai/ai-prompts/${encodeURIComponent(type)}`;
    return axios.post(url, data, DEFAULT_AUTH_HEADER);
}

export function getAIAgentsData(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/ai-agents?" + objectToUrlQuery(params));
}

export function saveAIAgentData(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/ai-agents", params);
}

export function createAgentSignature(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/user-agent-token", params);
}

export function createAgentSession(params) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/ai-sessions", params);
}

export function rerenderMarkdownContent(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/rerender-markdown?" + objectToUrlQuery(params));
}

export function getRecentTools(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/recent-tools?" + objectToUrlQuery(params));
}

export function getAIThreads(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/ai-threads?" + objectToUrlQuery(params));
}

export function createMessageFeedback(data) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/message-feedback", data);
}

export function updateMessageFeedback(data) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/message-feedback", data, { 
        params: { _method: 'PATCH' }
    });
}

export function deleteMessageFeedback(data) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/message-feedback", data, { 
        params: { _method: 'DELETE' }
    });
}

export function getFeedbackOptions(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/feedback-options?" + objectToUrlQuery(params));
}

export function getMessageFeedbackReports(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/message-feedback-reports?" + objectToUrlQuery(params));
}

export function getAssistantInstructionImprovementSuggestion(params) {
    return axios.get(process.env.REACT_APP_API_URL + "/openai/instruction-improvement-suggestion?" + objectToUrlQuery(params));
}

export function createTemplateAssistant(data) {
    return axios.post(process.env.REACT_APP_API_URL + "/openai/template-assistant", data);
}
